import { mitt } from '@jswork/event-mitt'

import { logInfo } from '@/helpers/Logger'

class Events {
  constructor() {
    if (Events._instance) {
      return Events._instance
    }
    Events._instance = this
    this.eventMitt = mitt()
  }

  emit(key, data) {
    logInfo(['%cEVENT.EMIT', 'color: yellow', key, data])
    this.eventMitt.emit(key, data)
  }

  off(key, callback) {
    this.eventMitt.off(key, callback)
  }

  on(key, callback) {
    this.eventMitt.on(key, callback)
  }

  one(key, callback) {
    this.eventMitt.one(key, callback)
  }

  once(key, callback) {
    this.eventMitt.once(key, callback)
  }
}

export default new Events()
